import * as HttpService from "../services/common-services/HttpService";

export function login(UserData) {
  return HttpService.postForm("connect/token", UserData, "IDP");
}
